/*global angular */
'use strict';

angular.module('MrDWebApp')
  .controller('HistoryCtrl', function($scope, $cookies, storage, $http, $state, $rootScope, orders, invoiceFactory) {

    var _history = this;

    $scope._rc.bodyClass = 'html-history';

    $rootScope.$broadcast('loading:show');

    /* Analytics */ $scope._rc.trackNavigateOrderHistory();

    _history.orders = orders;

    orders.$promise.then(function () {

      $rootScope.$broadcast('loading:hide');

    },function(){
      // Login Failed..
      /* @todo: Remove? */
      $state.go('login');
    });

    _history.orderHistoryClick = function(order){

      $state.go('details', {
        orderID:order.id,
        userID:order.customer.id
      });

    };
  
    _history.sendInvoice = function(order){
      if(order.email === order.original){
        invoiceFactory.invoice(order.id);
      } else {
        invoiceFactory.invoiceAlternative(order.id,order.email);
      }
    };

    _history.promptSendInvoice = function(order){
      
      $rootScope.$broadcast('global_message:show',{
        'name': 'send_invoice',
        'for_state': 'history',
        'error' : {
          'friendly_message': 'Send order invoice to the following email address.'
        },
        'confirm' : {
          'label': 'Send Invoice',
          'action': 'action',
          'value': {'id' : order.id, 'email': order.customer.email, 'original': order.customer.email},
          'value_object': _history
        },
        'deny' : {
          'label': 'Cancel',
          'action': 'close',
          'value': true,
          'value_object': null
        }
      });

    };


  });
